import { DateTime } from "luxon";
import type { ChatMessage } from "@/components/shared/chat-message-types";
import type { TrainingMessage } from "@/lib/api/training-simulator/training-simulator";

/**
 * Maps a simulator message onto the shared ChatMessage shape so it can render
 * through the same bubble component as real chat, without any Sendbird coupling.
 */
export function normalizeTrainingMessage(
  message: TrainingMessage,
): ChatMessage {
  return {
    id: message.id,
    kind: "message",
    text: message.content,
    createdAt: DateTime.fromISO(message.created_at).toMillis(),
  };
}
